module.exports = __webpack_public_path__ + "img/photo-07.d61270f9.jpg";